export default __webpack_public_path__ + "static/media/Guru-Parampara-34.d21c8a4c.png";